module.exports = __webpack_public_path__ + "static/ABWA-f0362247eab3a1c719f28e58e83795c4.svg";